import React from 'react';
import { Stack, Button } from '@mui/material';
import {
  ChatOutlined as ChatIcon,
  ArrowForwardOutlined as ArrowForwardIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const ClientActions = ({ hasActiveConversation, onChat, onDetails }) => {
  const { t } = useTranslation();

  return (
    <Stack direction="row" spacing={1}>
      <Button
        variant="outlined"
        startIcon={<ChatIcon />}
        onClick={onChat}
        size="small"
        disabled={!hasActiveConversation}
        sx={{
          flex: 1,
          borderRadius: 1.5,
          py: 0.5,
          px: 1.5,
          // Borda neutra; hover e disabled ficam no padrão do outlined do MUI.
          borderColor: 'divider',
        }}
      >
        {t('clients.chat')}
      </Button>
      <Button
        variant="contained"
        endIcon={<ArrowForwardIcon />}
        onClick={onDetails}
        size="small"
        sx={{
          flex: 1,
          borderRadius: 1.5,
          py: 0.5,
          px: 1.5,
        }}
      >
        {t('clients.viewDetails')}
      </Button>
    </Stack>
  );
};

export default ClientActions;
